import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    // Clear any existing timeout
    clearTimeout(this.timeout)

    // Debounce the submit - wait 300ms after user stops typing
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 300)
  }
}
